import { Component, h } from '@stencil/core';
import { initFCWidgetChat } from '../../../../../../shared/helpers/livechat.helper';
import get from 'lodash/get';

@Component({
  styleUrl: 'contact-livechat-login-popup.scss',
  tag: 'contact-livechat-login-popup',
})
export class ContactEmailLoginPopup {
  translate = (key) => {
    return get(window['loginSidebar'], key, key);
  }

  render() {
    return <a href="#" onClick={() => initFCWidgetChat()}><b>{this.translate('liveChat')}</b></a>
  }
}
